import type { ChakraProps } from '@chakra-ui/react-v2';
import moment from 'moment';

// TODO: replace moment
import { Text, VStack } from '@frontend/legacy-components';
import { useDateFormat } from '@frontend/utils';

import { EmptyCellContent } from './EmptyCellContent';

export type DateTimeCellContentProps = ChakraProps & {
  dateTime?: string | null;
};

export const DateTimeCellContent = ({
  dateTime,
  ...props
}: DateTimeCellContentProps): React.ReactElement => {
  const { dateFormat, timeFormat } = useDateFormat();
  if (dateTime) {
    const dateStr = moment(dateTime).local().format(dateFormat);
    const timeStr = moment(dateTime).local().format(timeFormat);

    return (
      <VStack spacing={0} alignItems="stretch">
        <Text textAlign="inherit" {...props}>
          {dateStr}
        </Text>
        <Text textAlign="inherit" size={'sm'} color={'feature.secondary'}>
          {timeStr}
        </Text>
      </VStack>
    );
  } else {
    return <EmptyCellContent textAlign={'end'} />;
  }
};
